<template>
  <div>
    <p>{{ desc }}</p>
  </div>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {
      desc: "",
    }
  },
  components: {},
  mounted() {
    const vueInstance = this
    if (vueInstance.$route.name == "NoAuthorized") {
      vueInstance.desc = vueInstance.$t("nopermision.callForHelp")
    } else if (vueInstance.$route.name === "NotFoundUrl") {
      vueInstance.desc = "The Page Is Not Found"
    } else {
      vueInstance.desc = "Error"
    }
  },
}
</script>
